import(/* webpackMode: "eager" */ "/home/developer/www/bazz.bet/bzfront/node_modules/swiper/swiper-bundle.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/src/components/Banner/Banner.tsx");
;
import(/* webpackMode: "eager" */ "/home/developer/www/bazz.bet/bzfront/src/components/layouts/container/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/src/domains/games/components/games-preview/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/src/domains/providers/components/providers-preview/index.tsx");
